import gql from 'graphql-tag'

export const getSettings = () => {
    return {
        query: gql`
            query GetSettings {
                getSettings {
                    tsMessage
                }
            }
        `,
    }
}

export const updateSettings = (tsMessage) => {
    return {
        mutation: gql`
            mutation UpdateSettings($tsMessage: String) {
                updateSettings(tsMessage: $tsMessage) {
                    tsMessage
                }
            }
        `,
        variables: {
            tsMessage: tsMessage,
        },
    }
}
